// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/kubernetes/v1/scaledobject.proto (package chalk.kubernetes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/kubernetes/v1/scaledobject.proto.
 */
export const file_chalk_kubernetes_v1_scaledobject: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectTargetRef
 */
export type KubernetesScaledObjectTargetRef = Message<"chalk.kubernetes.v1.KubernetesScaledObjectTargetRef"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string api_version = 2;
   */
  apiVersion: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string env_source_container_name = 4;
   */
  envSourceContainerName: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectTargetRef.
 * Use `create(KubernetesScaledObjectTargetRefSchema)` to create a new message.
 */
export const KubernetesScaledObjectTargetRefSchema: GenMessage<KubernetesScaledObjectTargetRef> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 0);

/**
 * GroupVersionKindResource provides unified structure for schema.GroupVersionKind and Resource
 *
 * @generated from message chalk.kubernetes.v1.KubernetesGroupVersionKindResource
 */
export type KubernetesGroupVersionKindResource = Message<"chalk.kubernetes.v1.KubernetesGroupVersionKindResource"> & {
  /**
   * @generated from field: string group = 1;
   */
  group: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string resource = 4;
   */
  resource: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesGroupVersionKindResource.
 * Use `create(KubernetesGroupVersionKindResourceSchema)` to create a new message.
 */
export const KubernetesGroupVersionKindResourceSchema: GenMessage<KubernetesGroupVersionKindResource> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 1);

/**
 * Condition to store the condition state
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectCondition
 */
export type KubernetesScaledObjectCondition = Message<"chalk.kubernetes.v1.KubernetesScaledObjectCondition"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: optional string message = 4;
   */
  message?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectCondition.
 * Use `create(KubernetesScaledObjectConditionSchema)` to create a new message.
 */
export const KubernetesScaledObjectConditionSchema: GenMessage<KubernetesScaledObjectCondition> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 2);

/**
 * HealthStatus is the status for a ScaledObject's health
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectHealthStatus
 */
export type KubernetesScaledObjectHealthStatus = Message<"chalk.kubernetes.v1.KubernetesScaledObjectHealthStatus"> & {
  /**
   * @generated from field: optional int32 number_of_failures = 1;
   */
  numberOfFailures?: number;

  /**
   * @generated from field: optional string status = 2;
   */
  status?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectHealthStatus.
 * Use `create(KubernetesScaledObjectHealthStatusSchema)` to create a new message.
 */
export const KubernetesScaledObjectHealthStatusSchema: GenMessage<KubernetesScaledObjectHealthStatus> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 3);

/**
 * AuthenticationRef points to the TriggerAuthentication or ClusterTriggerAuthentication object
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectAuthenticationRef
 */
export type KubernetesScaledObjectAuthenticationRef = Message<"chalk.kubernetes.v1.KubernetesScaledObjectAuthenticationRef"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string kind = 2;
   */
  kind?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectAuthenticationRef.
 * Use `create(KubernetesScaledObjectAuthenticationRefSchema)` to create a new message.
 */
export const KubernetesScaledObjectAuthenticationRefSchema: GenMessage<KubernetesScaledObjectAuthenticationRef> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 4);

/**
 * ScaleTriggers reference the scaler that will be used
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectTrigger
 */
export type KubernetesScaledObjectTrigger = Message<"chalk.kubernetes.v1.KubernetesScaledObjectTrigger"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: bool use_cached_metrics = 3;
   */
  useCachedMetrics: boolean;

  /**
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectAuthenticationRef authentication_ref = 5;
   */
  authenticationRef?: KubernetesScaledObjectAuthenticationRef;

  /**
   * @generated from field: optional string metric_type = 6;
   */
  metricType?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectTrigger.
 * Use `create(KubernetesScaledObjectTriggerSchema)` to create a new message.
 */
export const KubernetesScaledObjectTriggerSchema: GenMessage<KubernetesScaledObjectTrigger> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 5);

/**
 * Fallback is the spec for fallback options
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectFallback
 */
export type KubernetesScaledObjectFallback = Message<"chalk.kubernetes.v1.KubernetesScaledObjectFallback"> & {
  /**
   * @generated from field: int32 failure_threshold = 1;
   */
  failureThreshold: number;

  /**
   * @generated from field: int32 replicas = 2;
   */
  replicas: number;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectFallback.
 * Use `create(KubernetesScaledObjectFallbackSchema)` to create a new message.
 */
export const KubernetesScaledObjectFallbackSchema: GenMessage<KubernetesScaledObjectFallback> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 6);

/**
 * ScalingModifiers describes advanced scaling logic options like formula
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectScalingModifiers
 */
export type KubernetesScaledObjectScalingModifiers = Message<"chalk.kubernetes.v1.KubernetesScaledObjectScalingModifiers"> & {
  /**
   * @generated from field: optional string formula = 1;
   */
  formula?: string;

  /**
   * @generated from field: optional string target = 2;
   */
  target?: string;

  /**
   * @generated from field: optional string activation_target = 3;
   */
  activationTarget?: string;

  /**
   * @generated from field: optional string metric_type = 4;
   */
  metricType?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectScalingModifiers.
 * Use `create(KubernetesScaledObjectScalingModifiersSchema)` to create a new message.
 */
export const KubernetesScaledObjectScalingModifiersSchema: GenMessage<KubernetesScaledObjectScalingModifiers> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 7);

/**
 * HorizontalPodAutoscalerConfig specifies horizontal scale config
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectHPAConfig
 */
export type KubernetesScaledObjectHPAConfig = Message<"chalk.kubernetes.v1.KubernetesScaledObjectHPAConfig"> & {
  /**
   * Note: behavior field (autoscalingv2.HorizontalPodAutoscalerBehavior) is complex and omitted for now
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectHPAConfig.
 * Use `create(KubernetesScaledObjectHPAConfigSchema)` to create a new message.
 */
export const KubernetesScaledObjectHPAConfigSchema: GenMessage<KubernetesScaledObjectHPAConfig> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 8);

/**
 * AdvancedConfig specifies advance scaling options
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectAdvancedConfig
 */
export type KubernetesScaledObjectAdvancedConfig = Message<"chalk.kubernetes.v1.KubernetesScaledObjectAdvancedConfig"> & {
  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectHPAConfig horizontal_pod_autoscaler_config = 1;
   */
  horizontalPodAutoscalerConfig?: KubernetesScaledObjectHPAConfig;

  /**
   * @generated from field: bool restore_to_original_replica_count = 2;
   */
  restoreToOriginalReplicaCount: boolean;

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectScalingModifiers scaling_modifiers = 3;
   */
  scalingModifiers?: KubernetesScaledObjectScalingModifiers;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectAdvancedConfig.
 * Use `create(KubernetesScaledObjectAdvancedConfigSchema)` to create a new message.
 */
export const KubernetesScaledObjectAdvancedConfigSchema: GenMessage<KubernetesScaledObjectAdvancedConfig> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 9);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectStatus
 */
export type KubernetesScaledObjectStatus = Message<"chalk.kubernetes.v1.KubernetesScaledObjectStatus"> & {
  /**
   * @generated from field: string scale_target_kind = 1;
   */
  scaleTargetKind: string;

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesGroupVersionKindResource scale_target_gvkr = 2;
   */
  scaleTargetGvkr?: KubernetesGroupVersionKindResource;

  /**
   * @generated from field: optional int32 original_replica_count = 3;
   */
  originalReplicaCount?: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_active_time = 4;
   */
  lastActiveTime?: Timestamp;

  /**
   * @generated from field: repeated string external_metric_names = 5;
   */
  externalMetricNames: string[];

  /**
   * @generated from field: repeated string resource_metric_names = 6;
   */
  resourceMetricNames: string[];

  /**
   * @generated from field: optional string composite_scaler_name = 7;
   */
  compositeScalerName?: string;

  /**
   * @generated from field: repeated chalk.kubernetes.v1.KubernetesScaledObjectCondition conditions = 8;
   */
  conditions: KubernetesScaledObjectCondition[];

  /**
   * @generated from field: map<string, chalk.kubernetes.v1.KubernetesScaledObjectHealthStatus> health = 9;
   */
  health: { [key: string]: KubernetesScaledObjectHealthStatus };

  /**
   * @generated from field: optional int32 paused_replica_count = 10;
   */
  pausedReplicaCount?: number;

  /**
   * @generated from field: string hpa_name = 11;
   */
  hpaName: string;

  /**
   * @generated from field: optional string triggers_types = 12;
   */
  triggersTypes?: string;

  /**
   * @generated from field: optional string authentications_types = 13;
   */
  authenticationsTypes?: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectStatus.
 * Use `create(KubernetesScaledObjectStatusSchema)` to create a new message.
 */
export const KubernetesScaledObjectStatusSchema: GenMessage<KubernetesScaledObjectStatus> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 10);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectSpec
 */
export type KubernetesScaledObjectSpec = Message<"chalk.kubernetes.v1.KubernetesScaledObjectSpec"> & {
  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectTargetRef scale_target_ref = 1;
   */
  scaleTargetRef?: KubernetesScaledObjectTargetRef;

  /**
   * @generated from field: optional int32 polling_interval = 2;
   */
  pollingInterval?: number;

  /**
   * @generated from field: optional int32 initial_cooldown_period = 3;
   */
  initialCooldownPeriod?: number;

  /**
   * @generated from field: optional int32 cooldown_period = 4;
   */
  cooldownPeriod?: number;

  /**
   * @generated from field: optional int32 idle_replica_count = 5;
   */
  idleReplicaCount?: number;

  /**
   * @generated from field: optional int32 max_replica_count = 6;
   */
  maxReplicaCount?: number;

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectAdvancedConfig advanced = 7;
   */
  advanced?: KubernetesScaledObjectAdvancedConfig;

  /**
   * @generated from field: repeated chalk.kubernetes.v1.KubernetesScaledObjectTrigger triggers = 8;
   */
  triggers: KubernetesScaledObjectTrigger[];

  /**
   * @generated from field: optional chalk.kubernetes.v1.KubernetesScaledObjectFallback fallback = 9;
   */
  fallback?: KubernetesScaledObjectFallback;

  /**
   * @generated from field: optional int32 min_replica_count = 10;
   */
  minReplicaCount?: number;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectSpec.
 * Use `create(KubernetesScaledObjectSpecSchema)` to create a new message.
 */
export const KubernetesScaledObjectSpecSchema: GenMessage<KubernetesScaledObjectSpec> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 11);

/**
 * Can't find official protos; this is a manual implementation of a subset of ScaledObject fields.
 * Types made by referencing the keda go client.
 * Kept for backward compatibility with existing code
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObjectData
 */
export type KubernetesScaledObjectData = Message<"chalk.kubernetes.v1.KubernetesScaledObjectData"> & {
  /**
   * typeMeta = 1
   * objectMeta = 2
   *
   * @generated from field: chalk.kubernetes.v1.KubernetesScaledObjectSpec spec = 3;
   */
  spec?: KubernetesScaledObjectSpec;

  /**
   * @generated from field: chalk.kubernetes.v1.KubernetesScaledObjectStatus status = 4;
   */
  status?: KubernetesScaledObjectStatus;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObjectData.
 * Use `create(KubernetesScaledObjectDataSchema)` to create a new message.
 */
export const KubernetesScaledObjectDataSchema: GenMessage<KubernetesScaledObjectData> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 12);

/**
 * Full ScaledObject with metadata
 *
 * @generated from message chalk.kubernetes.v1.KubernetesScaledObject
 */
export type KubernetesScaledObject = Message<"chalk.kubernetes.v1.KubernetesScaledObject"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string namespace = 2;
   */
  namespace: string;

  /**
   * @generated from field: map<string, string> labels = 3;
   */
  labels: { [key: string]: string };

  /**
   * @generated from field: map<string, string> annotations = 4;
   */
  annotations: { [key: string]: string };

  /**
   * @generated from field: int64 creation_timestamp = 5;
   */
  creationTimestamp: bigint;

  /**
   * @generated from field: chalk.kubernetes.v1.KubernetesScaledObjectSpec spec = 6;
   */
  spec?: KubernetesScaledObjectSpec;

  /**
   * @generated from field: chalk.kubernetes.v1.KubernetesScaledObjectStatus status = 7;
   */
  status?: KubernetesScaledObjectStatus;

  /**
   * @generated from field: string cluster_name = 8;
   */
  clusterName: string;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesScaledObject.
 * Use `create(KubernetesScaledObjectSchema)` to create a new message.
 */
export const KubernetesScaledObjectSchema: GenMessage<KubernetesScaledObject> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_scaledobject, 13);

